const catalogGetters = {
  getCategories: (state) => state.categories,
  getCategoriesForSelect: (state) => state.categoriesSelect,
  getProducts: (state) => state.products,
  getImportedProducts: (state) => state.importedProducts,
  getImportedProductsTotal: (state) => state.importedProductsTotal,
  getCategory: (state) => state.category,
  getApp: (state) => state.app,
  getProduct: (state) => state.product,
  getProductsSelect: (state) => state.productsSelect,
  getProductStatusesForSelect: (state) => state.productStatusesSelect,
  getVendors: (state) => state.vendorList,
  getVendor: (state) => state.vendor,
  getSuppliers: (state) => state.suppliersList,
  getSupplier: (state) => state.supplier,
  getPrices: (state) => state.prices,
  getPrice: (state) => state.price,
  getPriceCategories: (state) => state.priceCategories,
  getPriceList: (state) => state.priceList,
  getSinglePriceList: (state) => state.singlePriceList,
  getWarehouses: (state) => state.warehouses,
  getWarehouseCount: (state) => state.warehouseCount,
  getBrochureCategories: (state) => state.brochureCategories,
  getBrochures: (state) => state.brochures,
  getBrochure: (state) => state.brochure,
  getTotalBrochureFiles: (state) => state.totalBrochureFiles,
  getBrochureFiles: (state) => state.brochureFiles
}

export { catalogGetters }
